import styled from "styled-components";
import arrowIcon from "./../../../abc/src/data/icons/chevron-thin-down-dark.svg";
import { isTablet, isMobile } from "react-device-detect";

export const MobileFilter = styled.div`
  width: 100%;
  padding: ${(sportsbook) => sportsbook && isMobile && "1rem 0"};
  label {
    color: var(--gamesCategoriesMobileFilterLabelColor);
    font-size: 16px;
    /* font-family: "Catamaran", Fallback, sans-serif; */

    letter-spacing: 1px;
  }
  .form-control {
    background-image: url(${arrowIcon}) !important;
    border: none;
  }
  select {
    background: none;
    height: 100%;
    padding: 0;
    font-size: 16px;
    letter-spacing: 1px;
    font-size: 1rem;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    text-transform: capitalize;
    text-align: left;
    color: var(--gamesCategoriesMobileFilterSelectColor);

    option {
      background-color: var(--gamesCategoriesMobileFilterOptionBg);
      color: var(--gamesCategoriesMobileFilterOptionColor);
    }
  }
  select:focus {
    color: var(--gamesCategoriesMobileFilterSelectFocusColor);
    border: none !important;
    background-color: var(--gamesCategoriesMobileFilterSelectFocusBg);
    box-shadow: none !important;
    outline: none !important;
  }

  @media (max-width: 770px) {
    display: flex;
    font-weight: 600;
    label {
      margin: 0;
      margin-right: 7px;
    }
  }
`;

export const StyledGameSeachLabel = styled.label`
  position: relative;
  width: var(--gamesCategoriesSearchLabelWidth);

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    border: 1px solid transparent;
    -webkit-text-fill-color: var(--gamesCategoriesSearchLabelAutofillColor);
    -webkit-box-shadow: 0 0 0px 1000px transparent inset;
    box-shadow: 0 0 0px 1000px transparent inset;
    transition: background-color 5000s ease-in-out 0s;
  }

  .icon {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    color: silver;
  }
  input {
    border-radius: var(--gamesCategoriesSearchInputBorderRadius);
    border: var(--gamesCategoriesSearchInputBorder);
    &.form-control {
      text-align: left;
      color: var(--gamesCategoriesSearchInputColor);
      height: var(--gamesCategoriesSearchInputHeight);
      padding: var(--gamesCategoriesSearchInputPadding);
      background-color: var(--gamesCategoriesSearchInputBg);
      border: none;
      &::placeholder {
        color: var(--gamesCategoriesSearchInputPlaceholderColor);
      }
    }
  }

  @media screen and (max-width: 767px) {
    -webkit-box-shadow: 0px 4px 10px -5px var(--headerbg);
    -moz-box-shadow: 0px 4px 10px -5px var(--headerbg);
    box-shadow: 0px 4px 10px -5px var(--headerbg);
    border-bottom-left-radius: 30px;
    border-bottom-right-radius: 30px;

    input {
      &.form-control {
        padding: var(--gamesCategoriesSearchInputPaddingMobile);
      }
    }
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    -webkit-box-shadow: 0px 4px 10px -5px var(--headerbg);
    -moz-box-shadow: 0px 4px 10px -5px var(--headerbg);
    box-shadow: 0px 4px 10px -5px var(--headerbg);
    border-bottom-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
`;

export const StyledListGroup = styled.div.attrs({
  className: "list-group",
})`
  text-align: left;
  overflow-x: hidden;
  margin-top: var(--gamesCategoriesListGroupMarginTop);
  border-radius: var(--gamesCategoriesListGroupBorderRadius);
  background-color: var(--gamesCategoriesListGroupBg);

  height: 100%;
  max-height: 50vh;
  border: var(--gamesCategoriesListGroupBorder);

  max-width: var(--gamesCategoriesListGroupMaxWidth);

  &::-webkit-scrollbar-track {
    background-color: var(--gamesCategoriesListGroupScrollbarTrackBg);
    border-radius: var(--gamesCategoriesListGroupScrollbarTrackRadius);
  }
  &::-webkit-scrollbar-thumb {
    background-color: var(--gamesCategoriesListGroupScrollbarThumbBg);
  }

  div {
    box-shadow: 0px 0px 2px 0px var(--tabletext);
    height: 70px;
    color: var(--gamesCategoriesListGroupItemColor);
    position: relative;
    display: block;
    display: block;
    padding: 0.75rem 1.25rem;
    background-color: var(--gamesCategoriesListGroupItemBg);
  }

  a {
    padding: 0.5rem;
    background-image: url(data:image/png;base64,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);

    span {
      position: relative;
      top: 0px;
      right: 0px;
      font-size: 12px;
      opacity: 0.6;
      float: right;
    }
  }

  @media screen and (max-width: 767px) {
    position: relative;

    a {
      padding: 0.25rem;
    }
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    position: relative;
  }
`;

export const StyledFilterOption = styled.option.attrs((props) => ({
  className: props.opened ? "opened" : props.button ? " nav nav-link" : "",
}))`
  h2 {
    text-transform: uppercase;
  }
`;

export const StyledFilterButton = styled.button`
  font-family: var(--gamesCategoriesFilterBtnFontFamily);
  cursor: pointer;
  color: ${({ opened }) =>
    opened
      ? "var(--gamesCategoriesFilterBtnColorOpened)"
      : "var(--gamesCategoriesFilterBtnColor)"};
  font-weight: var(--gamesCategoriesFilterBtnFontWeight);
  text-transform: var(--gamesCategoriesFilterBtnTextTransform);
  background-color: ${({ opened }) =>
    opened ? "var(--gamesCategoriesFilterBtnBgOpened)" : "transparent"};

  text-decoration: ${({ opened }) =>
    opened ? "var(--gamesCategoriesFilterBtnTextDecorationOpened)" : ""};
  text-decoration-thickness: 3px;
  text-underline-offset: 8px;

  border-radius: ${({ opened }) =>
    opened ? "var(--gamesCategoriesFilterBtnBorderRadiusOpened)" : ""};
  outline: 0;
  border: ${({ opened }) =>
    opened ? "var(--gamesCategoriesFilterBtnBorderOpened)" : "none"};
  padding: ${() =>
    isTablet
      ? "var(--gamesCategoriesFilterBtnPaddingTablet)"
      : "var(--gamesCategoriesFilterBtnPadding)"};
  display: ${({ display }) => (display ? "none" : "")};
  -moz-outline-style: none;
  outline-style: none;
  font-size: ${() =>
    isTablet
      ? "var(--gamesCategoriesFilterBtnFontSizeTablet)"
      : "var(--gamesCategoriesFilterBtnFontSize)"};

  &:focus {
    outline: 0;
  }
`;

export const GameSearchWrapper = styled.div`
  margin: var(--gamesCategoriesSearchWrapperMargin);

  @media (max-width: 767px) {
    margin: var(--gamesCategoriesSearchWrapperMarginMobile);
  }
`;

export const StyledSearchName = styled.text`
  display: inline-block;
  overflow: hidden;
  max-width: 245px;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const StiledGamesInfo = styled.text`
  display: inline-flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

export const StyledQuickGameCategories = styled.div.attrs({
  className: "quick-game-categories",
})`
  position: var(--gamesCategoriesQuickCategoriesPosition);
  left: ${() =>
    isMobile
      ? "var(--gamesCategoriesQuickCategoriesLeft)"
      : "var(--gamesCategoriesQuickCategoriesLeftMd)"};
  transform: ${() =>
    isMobile
      ? "var(--gamesCategoriesQuickCategoriesTransform)"
      : "var(--gamesCategoriesQuickCategoriesTransformMd)"};
  z-index: 1;
  /* padding-top: ${isMobile ? "" : "40px"}; */
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  //align-items: spa;
  //align-content: space-between;
  text-transform: uppercase;
  letter-spacing: 1px;
  justify-content: flex-start;
  align-items: center;
  font-size: var(--gamesCategoriesQuickCategoriesFontSize);
  max-width: var(--gamesCategoriesQuickCategoriesMaxWidth, none);
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  font-weight: 600;

  &::-webkit-scrollbar {
    display: none;
  }

  @media screen and (min-width: 768px) {
    left: 200px;
    transform: none;
  }

  /* Tablet: header padding drops to 20px, so the header nav can start closer
     to the logo; show the scrollbar like on mobile. */
  @media screen and (min-width: 768px) and (max-width: 1024px) {
    #header & {
      left: var(--gamesCategoriesQuickCategoriesLeftTablet, 140px);
      max-width: var(
        --gamesCategoriesQuickCategoriesMaxWidthTablet,
        calc(100vw - 390px)
      );
      padding-bottom: 5px;
      scrollbar-width: auto;
      -ms-overflow-style: auto;

      &::-webkit-scrollbar {
        display: block;
        height: 4px;
      }
    }
  }

  a {
    background: none;
    font-family: var(--gamesCategoriesQuickCategoriesLinkFontFamily);
    padding: 0 var(--gamesCategoriesQuickCategoriesLinkPaddingX, 25px);
    font-weight: var(--gamesCategoriesQuickCategoriesLinkFontWeight);
    text-decoration: var(--gamesCategoriesQuickCategoriesLinkTextDecoration);
    text-decoration-color: var(
      --gamesCategoriesQuickCategoriesLinkTextDecorationColor
    );
    text-decoration-thickness: var(
      --gamesCategoriesQuickCategoriesLinkTextDecorationThickness
    );
    text-underline-offset: var(
      --gamesCategoriesQuickCategoriesLinkTextUnderlineOffset
    );
    transition: color 0.3s;
    flex-shrink: 0;
    white-space: nowrap;

    &:hover {
      background: none;
      color: var(--gamesCategoriesQuickCategoriesLinkHoverColor);
      //font-weight: bold;
      //color: white;
    }

    &.active {
      text-decoration: underline;
      text-decoration-color: var(--underlineOnIndex);
      text-decoration-thickness: 3px;
      text-underline-offset: 4px;
    }
  }
  //overflow: hidden;
  //max-width: 500px;
  //white-space: nowrap;
  //text-overflow: ellipsis;

  @media screen and (max-width: 767px) {
    display: flex;
    top: 80px;
    width: 100%;
    max-width: calc(100% - 20px);
    align-content: center;
    align-items: center;
    font-size: 0.9rem;
    position: absolute;
    left: 10px;
    transform: none;
    padding: 0px 10px 5px 0;
    scrollbar-width: auto;
    -ms-overflow-style: auto;

    &::-webkit-scrollbar {
      display: block;
      height: 4px;
    }

    a {
      padding: 0px var(--gamesCategoriesQuickCategoriesLinkPaddingXMobile, 10px);
      font-size: var(--gamesCategoriesQuickCategoriesFontSizeMobile, 1rem);
    }
  }
`;

/* Mobile "chips" variant of the header nav: pill links on a subtle background,
   fading edges and small arrows that show when there is more to scroll.
   Above 767px the wrapper is display: contents, so desktop is untouched. */
export const StyledQuickNavChips = styled.div.attrs({
  className: "quick-nav-chips",
})`
  display: contents;

  .quick-nav-arrow {
    display: none;
  }

  @media screen and (max-width: 767px) {
    display: block;
    position: absolute;
    top: 80px;
    left: 10px;
    width: calc(100% - 20px);
    z-index: 1;

    ${StyledQuickGameCategories} {
      position: relative;
      top: auto;
      left: auto;
      max-width: 100%;
      gap: 8px;
      /* base mobile style adds 5px bottom padding, which pushes the
         arrows (top: 50% of the wrapper) off-center */
      padding-top: 0;
      padding-bottom: 0;
      scroll-behavior: smooth;
      scrollbar-width: none;
      -ms-overflow-style: none;
      -webkit-mask-image: linear-gradient(
        to right,
        ${({ $fadeLeft }) =>
          $fadeLeft ? "transparent 0, #000 36px" : "#000 0"},
        ${({ $fadeRight }) =>
          $fadeRight ? "#000 calc(100% - 36px), transparent 100%" : "#000 100%"}
      );
      mask-image: linear-gradient(
        to right,
        ${({ $fadeLeft }) =>
          $fadeLeft ? "transparent 0, #000 36px" : "#000 0"},
        ${({ $fadeRight }) =>
          $fadeRight ? "#000 calc(100% - 36px), transparent 100%" : "#000 100%"}
      );

      &::-webkit-scrollbar {
        display: none;
      }

      a {
        padding: 5px 14px;
        border-radius: 8px;
        background: rgba(255, 255, 255, 0.1);
        background: var(
          --quickNavChipBg,
          color-mix(in srgb, currentColor 10%, transparent)
        );
        border: none;
        font-size: 0.8rem;
        transition: background 0.2s;

        &:hover {
          background: var(
            --quickNavChipBg,
            color-mix(in srgb, currentColor 10%, transparent)
          );
        }

        &.active {
          text-decoration: none;
          background: var(--quickNavChipActiveBg, var(--underlineOnIndex));
          color: var(--quickNavChipActiveColor, #fff);
        }
      }
    }

    .quick-nav-arrow {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 26px;
      height: 26px;
      padding: 0;
      border-radius: 50%;
      border: 1px solid rgba(255, 255, 255, 0.25);
      background: rgba(0, 0, 0, 0.65);
      color: #fff;
      z-index: 2;
      cursor: pointer;

      &.left {
        left: -4px;
      }
      &.right {
        right: -4px;
      }
      svg {
        width: 14px;
        height: 14px;
      }
    }
  }
`;
